import React from 'react';
import {
  Column,
  Container,
  Flex,
  Row,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import Table from 'src/components/Table/Table';
import { NoResultsMsg } from 'src/components/Table/NoResultsMsg';
import { ParentAdminTableHeader } from 'src/components/enterprise/Parents/Admin/ParentAdminsController/ParentAdminsTable/ParentAdminTableHeader/ParentAdminTableHeader';
import { EmailParentAdminsButton } from 'src/components/enterprise/Parents/Admin/ParentAdminsController/ParentAdminsTable/EmailParentAdminsButton/EmailParentAdminsButton';
import { TableSearchForm } from 'src/components/enterprise/Parents/TableSearchForm/TableSearchForm';
import { Pagination } from 'src/components/Pagination/Pagination';
import {
  IDiner,
  ISearchResults,
  SearchStatus,
} from 'src/utilities/useSearchHooks';
import { NumberOfParentAdmins } from 'src/components/enterprise/Parents/Admin/ParentAdminsController/ParentAdminsTable/NumberOfParentAdmins/NumberOfParentAdmins';
import { TIERED_ACCOUNTS_PAGE_SIZE } from 'src/components/enterprise/Parents/constants';

export interface ParentAdminsTableProps {
  children: React.ReactNode;
  searchResults: Pick<
    ISearchResults<IDiner>,
    | 'totalResults'
    | 'currentSearchPage'
    | 'totalPages'
    | 'firstItemNumberFromPage'
    | 'lastItemNumberFromPage'
    | 'searchStatus'
  >;
  onSearchClick: () => void;
  onPageChange: (page: number) => void;
}

export const ParentAdminsTable: React.FC<ParentAdminsTableProps> = ({
  children,
  searchResults,
  onSearchClick,
  onPageChange,
}) => {
  const {
    totalResults,
    currentSearchPage,
    totalPages,
    firstItemNumberFromPage,
    lastItemNumberFromPage,
  } = searchResults;

  const noParentAdminElement = <NoResultsMsg message="No admins found" />;
  const isLoading = searchResults.searchStatus === SearchStatus.LOADING;

  return (
    <Container>
      <Stack y="md">
        <Row>
          <Column phone={4}>
            <TableSearchForm
              onSearchClick={onSearchClick}
              placeholder="Search parent admin"
            />
          </Column>
          <Column phone={8}>
            <Flex justifyContent="flex-end">
              <EmailParentAdminsButton />
            </Flex>
          </Column>
        </Row>
      </Stack>

      <NumberOfParentAdmins
        firstItemNumberFromPage={firstItemNumberFromPage}
        lastItemNumberFromPage={lastItemNumberFromPage}
        totalResults={totalResults}
      />
      <Stack y="md">
        <Table
          header={() => <ParentAdminTableHeader />}
          headerInsets="none"
          body={() => (totalResults > 0 ? children : noParentAdminElement)}
          showFooter={false}
          isLoading={isLoading}
        />
      </Stack>
      {totalPages > 1 && (
        <Flex justifyContent="center">
          <Pagination
            page={currentSearchPage}
            pageSize={TIERED_ACCOUNTS_PAGE_SIZE}
            ellipses={false}
            rotate
            collectionSize={totalResults}
            pageChange={onPageChange}
          />
        </Flex>
      )}
    </Container>
  );
};
